import React, { useEffect, useState } from "react";
import { Typography, Slider, Grid, Box } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepSix(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    const marks = [
        {
            value: 0,
            label: 'Pas d\'accord',
        },
        {
            value: 5,
            label: 'Partiellement d\'accord',
        },
        {
            value: 10,
            label: 'Tout à fait d\'accord',
        }
    ];

    useEffect(() => {
        if (props.datas.behaviours && Object.keys(props.datas.behaviours).length >= 2) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        if(!datas.behaviours){
            datas.behaviours = {};
        }
        datas.behaviours[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, lorsque des voyageurs séjournent dans un logement en «location à court et moyen terme» , quel est son comportement :
            </Typography>
            <Grid container spacing={2} justifyContent='center' direction='row' className='borderTop'>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Les voyageurs considèrent ce logement comme un vrai « chez eux » et garde les mêmes habitudes qu’à leur domicile (entretenir le lieux, respecter le voisinage, consommer dans les commerces de proximité…)
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.behaviours && props.datas.behaviours['ownHome'] ? props.datas.behaviours['ownHome'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='ownHome'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Les voyageurs adoptent des comportements différents et profitent pleinement du lieux sans se soucier de leur environnement (voisin, logements…)
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.behaviours && props.datas.behaviours['notOwnHome'] ? props.datas.behaviours['notOwnHome'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='notOwnHome'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ModalFooter buttons={buttons} />
        </>
    )
}